module.exports = __webpack_public_path__ + "assets/img/home-card.ba9994d3.png";